// Custom.js was created so that the base theme is left unchanged, this allows for theme updates and
// keeps all custom changes in one place

// Handles the Get to know our products hover effect 
document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('.get-to-know .product-cards .product-card');

  productCards.forEach(card => {
    card.addEventListener('mouseover', function () {
      productCards.forEach(c => c.classList.remove('active'));
      this.classList.add('active');
    });
  });
});


// Sets all swiper slide heights to the height of the tallest slide
// this was added to keep all slides in line to match the bordered design
// Sets all swiper slide heights to the height of the tallest slide
function equalizeSwiperSlideHeights() {
  const swiperWrappers = document.querySelectorAll('.swiper-wrapper');

  swiperWrappers.forEach(wrapper => {
    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    let maxHeight = 0;

    slides.forEach(slide => {
      slide.style.height = 'auto';
    });

    slides.forEach(slide => {
      const height = slide.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    slides.forEach(slide => {
      slide.style.height = `${maxHeight}px`;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  equalizeSwiperSlideHeights();
});

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    equalizeSwiperSlideHeights();
  }, 150);
});

if (typeof Swiper !== 'undefined') {
  const originalSwiper = Swiper;

  window.Swiper = function (...args) {
    const instance = new originalSwiper(...args);

    if (args[0] && args[0].el) {
      instance.on('init', equalizeSwiperSlideHeights);
      instance.on('slideChangeTransitionEnd', equalizeSwiperSlideHeights);
    }

    return instance;
  };
  Object.assign(window.Swiper, originalSwiper);
}


document.addEventListener('DOMContentLoaded', () => {
  equalizeSwiperSlideHeights();
});

window.addEventListener('resize', () => {
  equalizeSwiperSlideHeights();
});

if (typeof Swiper !== 'undefined') {
  const originalSwiper = Swiper;

  window.Swiper = function (...args) {
    const instance = new originalSwiper(...args);

    if (args[0] && args[0].el) {
      instance.on('init', equalizeSwiperSlideHeights);
      instance.on('slideChangeTransitionEnd', equalizeSwiperSlideHeights);
    }

    return instance;
  };
  Object.assign(window.Swiper, originalSwiper);
}


// Handles the sticky image on custom article pages
(function () {
  const image = document.querySelector('.custom-article__image.hide-sm img');
  const container = document.querySelector('.custom-article');

  if (!image || !container) return;

  function updateFixedImage() {
    if (window.innerWidth < 891) {
      image.style.position = '';
      image.style.top = '';
      image.style.bottom = '';
      return;
    }

    const containerTop = container.getBoundingClientRect().top + window.scrollY;
    const containerHeight = container.offsetHeight;
    const imageHeight = image.offsetHeight;
    const scrollY = window.scrollY;

    const start = containerTop;
    const end = containerTop + containerHeight - imageHeight - 95.5;

    if (scrollY >= start && scrollY < end) {
      image.style.position = 'fixed';
      image.style.top = '95.5px';
      image.style.bottom = '';
    } else if (scrollY >= end) {
      image.style.position = 'absolute';
      image.style.top = 'initial';
      image.style.bottom = '0';
    } else {
      image.style.position = 'relative';
      image.style.top = '0';
      image.style.bottom = '';
    }
  }

  window.addEventListener('scroll', updateFixedImage);
  window.addEventListener('resize', updateFixedImage);
  document.addEventListener('DOMContentLoaded', updateFixedImage);
})();


// Handles the homepage logo animation and it's various states
// Commented out to revert the logo from design back to base theme
// document.addEventListener('DOMContentLoaded', () => {
//   const header = document.querySelector('.store-header__homepage');
//   if (!header) return;

//   const logoWrapper = document.getElementById('animated-logo-wrapper');
//   const logoImg = document.getElementById('animated-logo');
//   const announce = document.querySelector('.announcement-bar');
//   const firstSection = document.querySelector('main > section');

//   if (!logoWrapper || !logoImg || !announce || !firstSection) {
//     console.warn('Missing required elements for animated header or logo');
//     return;
//   }

//   gsap.registerPlugin(ScrollTrigger);

//   const initLogoAnimation = () => {
//     ScrollTrigger.getAll().forEach(t => t.kill());

//     const announcementHeight = announce.offsetHeight;
//     const headerHeight = header.offsetHeight;
//     const startTop = headerHeight + announcementHeight - 30;

//     logoWrapper.style.top = `${startTop}px`;

//     const isMobile = window.innerWidth <= 699;
//     const topOffset = header.offsetTop - announcementHeight + (isMobile ? 15 : 30);


//     gsap.to([logoWrapper, logoImg], {
//       width: '0vw',
//       top: `${topOffset}px`,
//       ease: 'power2.out',
//       left: window.innerWidth <= 699 ? '44.5%' : '50%',
//       scrollTrigger: {
//         trigger: announce,
//         start: 'top top',
//         end: 'bottom top',
//         scrub: true,
//       },
//     });
    
//     header.style.position = 'fixed';
//     header.style.top = `${announcementHeight}px`;
//     header.style.left = '0';
//     header.style.right = '0';
//     header.style.zIndex = '100';

//     gsap.to(header, {
//       top: 0,
//       ease: 'none',
//       scrollTrigger: {
//         trigger: announce,
//         start: 'top top',
//         end: `+=${announcementHeight}`,
//         scrub: true,
//       },
//     });
//   };

//   window.addEventListener('scroll', () => {
//     const badges = document.querySelectorAll('.home-badge');
//     const atTop = window.scrollY === 0;
  
//     badges.forEach(badge => {
//       badge.classList.toggle('hidden', !atTop);
//     });
//   });

//   initLogoAnimation();

//   window.addEventListener('resize', () => {
//     clearTimeout(window._resizeTimeout);
//     window._resizeTimeout = setTimeout(() => {
//       initLogoAnimation();
//     }, 150);
//   });

//   void logoWrapper.offsetWidth;
//   requestAnimationFrame(() => {
//     logoWrapper.style.transition = 'opacity 0.6s ease';
//     logoWrapper.classList.add('visible');
//   });

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       header.classList.toggle('has-scrolled', !entry.isIntersecting);
//     },
//     { root: null, threshold: 0 }
//   );

//   observer.observe(firstSection);
// });

// Handles adding buttons to the mobile nav, this targets the last link in the menu list
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.mobile-target__add-button');

  targets.forEach(target => {
    const lastItem = target.querySelector('li:last-child .reversed-link');
    if (lastItem) {
      lastItem.classList.add('button__orange');
    }
  });
});

// Handles the background colour of the Klarna placement widget
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const klarnaEl = document.querySelector('klarna-placement');

    if (klarnaEl && klarnaEl.shadowRoot) {
      const container = klarnaEl.shadowRoot.querySelector('.container');
      if (container) {
        container.style.background = '#EEEADE';
        container.style.border = '1px solid #000';
        observer.disconnect();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});


